import { createContext, useContext, useEffect, useState, useRef } from "react";
import api from "../lib/api";
import i18n from "../i18n";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const userSetRef = useRef(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/auth/me");
        if (!userSetRef.current) {
          setUser(data);
          userSetRef.current = true;
        }
      } catch (e) {
        // keep user as null only if no login happened in the meantime
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("rp_token", data.token);
    userSetRef.current = true;
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const preferred_language = (i18n.language || "fr").split("-")[0];
    const { data } = await api.post("/auth/register", { ...payload, preferred_language });
    if (data.token) localStorage.setItem("rp_token", data.token);
    userSetRef.current = true;
    setUser(data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) { /* ignore */ }
    localStorage.removeItem("rp_token");
    userSetRef.current = false;
    setUser(null);
  };

  const refreshUser = async () => {
    const { data } = await api.get("/auth/me");
    userSetRef.current = true;
    setUser(data);
    return data;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
